import { Component, NgZone } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { LocationProvider } from './../../providers/locationProvider';

import { FilterState } from '../../providers/filter_state';

declare var google:any;
declare var gmaps: any;

@Component({
  selector: 'page-llista',
  templateUrl: 'llista.html'
})
export class Llista {

  public locations: any = [];
  public locationsFiltered: any = [];
  public lupaActive: boolean = false;
  public preFiximgurl: string = "https://res.cloudinary.com/mei/image/fetch/w_300,h_300,c_thumb/";
  public filtres: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public locationProvider: LocationProvider, private zone:NgZone, private filterState: FilterState, ) {}

    ionViewWillEnter() {
      console.log("2222");
      this.filtres = this.filterState.getFiltre();
      this.locations = [];
      this.loadArray();
    }

    changeActive(event){
      this.lupaActive = event.value;
    }

    takeLlistatFiltres(event){
      this.filtres = event.value;
      this.filterLocations();
    }

    filterLocations () {
      //console.log(this.locations);
      this.locationsFiltered = this.locations.filter(location => {
        let isInRegim = this.filtres.regim.some(filtre => {
          filtre = this.trimAndLowerCase(filtre);
          return this.trimAndLowerCase(location.Tipologia).indexOf(filtre) !== -1
            || this.trimAndLowerCase(location.Règim_prop).indexOf(filtre) !== -1
        });
        let isInTipologia = this.filtres.tipologia.some(filtre => {
          filtre = filtre.trim().toLowerCase();
          return this.trimAndLowerCase(location.Tipologia).indexOf(filtre) !== -1
            || this.trimAndLowerCase(location.Règim_prop).indexOf(filtre) !== -1;
        });
        return isInRegim && isInTipologia;
      });
      //console.log(this.locationsFiltered);

      this.zone.run(() => {
            console.log('enabled time travel');
        });
    }

  trimAndLowerCase (string) {
    return string.trim().toLowerCase();
  }

  mapHeight(){
    return (!this.lupaActive)?"llistat_total":"llistat_parcial";
  }

  loadArray() {
    console.log("aaaa");
    let style = {
      fillColor: '#333388',
      fillOpacity: 0.35,
      strokeColor: '#FFFFFF',
      strokeWeight: 1,
      strokeOpacity: 1,
      zIndex: 0
    };

    let url = 'https://services.arcgis.com/WNsrZDHEJ88NE4N8/ArcGIS/rest/services/Espais_lliures_polígons/FeatureServer/0';
    let layer = new gmaps.ags.Layer(url);
    let params = {
      returnGeometry: true,
      where: "1 = 1",
      outFields: ["OBJECTID", "Poligon","Adreça_ubi","Tipologia","Sup_interv","Superf_m2","Règim_prop","Disponibil","Empresa_Im","Tl_1contac","Tl_2contac","E_mail","Contacte","Descripció","foto","web_immob"],
      overlayOptions: style
    };
    layer.query(params, (rs) => {
      rs.features.forEach(element => this.setupFeature(element));
      this.filterLocations();
    });

  }

  setupFeature (feat) {
    if(feat.geometry!=undefined && feat.attributes.Disponibil=="Sí"){
      let g = feat.geometry[0];//V3 supports multiple rings, so should have only 1 element

      feat.attributes["geo"] = this.getPolyCenter(g);
      this.locations.push(feat.attributes);
    }
  }

  getPolyCenter(poly) {
    let lat = 0;
    let lng = 0;
    let c = 0;
    let paths = poly.getPaths();
    for (var j = 0, jc = paths.getLength(); j < jc; j++) {
      let path = paths.getAt(j);
      for (var k = 0, kc = path.getLength(); k < kc; k++) {
        let latlng = path.getAt(k);
        lat += latlng.lat();
        lng += latlng.lng();
        c++;
      }
    }
    return c > 0 ? { "lat" : lat / c, "lng" : lng / c } : null;
  }

  setImg(urlFoto){
    if(urlFoto == " "){
      return "assets/img/gris.jpg";
    }else{
      return this.preFiximgurl + urlFoto;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/llista/llista.ts